var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"inputs":_vm.inputs,"disable-sticky-buttons":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }